export const PROJECT = {
    name: "LeBonBon",
    ticker: "$LBRON",
    tagline: "just a small guy, holding his cup",
    launchDateISO: "2026-05-20T00:00:00Z",
    platform: "Pump.fun",
    telegram: "https://t.me/lebonbonofficial1",
    contractAddress: "TBA — DROPPING ON LAUNCH DAY",
};

export const ASSETS = {
    heroMeme: "https://customer-assets.emergentagent.com/job_b546e2d1-de19-4b5e-825f-d658f02fefac/artifacts/rg5uog6r_Skjermbilde%202026-04-14%20190750.png",
    visionPromo: "https://customer-assets.emergentagent.com/job_b546e2d1-de19-4b5e-825f-d658f02fefac/artifacts/5lsm8awj_lebron.jpg",
    coinChart: "https://customer-assets.emergentagent.com/job_b546e2d1-de19-4b5e-825f-d658f02fefac/artifacts/ax9vhc4u_Skjermbilde%202026-04-14%20231517.png",
};

export const ROADMAP = [
    {
        id: 1,
        title: "Foundation",
        status: "complete",
        summary: "Built a strong base. Grew Telegram organically, set up structure, and aligned the community on the vision.",
    },
    {
        id: 2,
        title: "Growth & Awareness",
        status: "complete",
        summary: "Expanded visibility. More engagement, Spaces, discussions, and active community moments as we grew.",
    },
    {
        id: 3,
        title: "Expansion",
        status: "current",
        summary: "Stronger push and more exposure. Roles for the most active members. A dedicated marketers / shillers / raiders TG group to plan a bullish launch.",
    },
    {
        id: 4,
        title: "Launch",
        status: "upcoming",
        summary: "Coin goes live on Pump.fun. The community we built becomes the driving force behind LeBonBon.",
    },
];

export const PHASE3_CHECKLIST = [
    "Stronger marketing push & wider exposure",
    "Major parts of the project taking shape ahead of launch",
    "Assigning roles to the most active members & top contributors",
    "Building a dedicated TG group for marketers, shillers & raiders",
    "Locking in strategies for a bullish launch on Pump.fun",
];

// kept for backwards compatibility / archived achievements
export const PHASE1_CHECKLIST = [
    "Growing the community organically",
    "Building a strong and active Telegram",
    "Setting up structure (welcome system, bots, moderation)",
    "Starting real discussions about the project",
    "Explaining the vision, aim, and direction clearly",
];
